import { useEffect, useState } from "react";

const maintenanceStartsAt = Date.parse("2026-09-15T18:00:00Z");
const dismissalKey = `foodics-bi:maintenance-dismissed:${maintenanceStartsAt}`;

export function MaintenanceAnnouncement() {
  const [visible, setVisible] = useState(() => {
    if (Date.now() >= maintenanceStartsAt) return false;
    try {
      return localStorage.getItem(dismissalKey) !== "true";
    } catch {
      return true;
    }
  });

  useEffect(() => {
    const remaining = maintenanceStartsAt - Date.now();
    if (remaining <= 0) {
      setVisible(false);
      return;
    }

    const timeout = window.setTimeout(() => setVisible(false), remaining);
    return () => window.clearTimeout(timeout);
  }, []);

  if (!visible) return null;

  return (
    <aside
      aria-label="Scheduled maintenance announcement"
      role="status"
      className="flex w-full items-start justify-center gap-3 border-b border-amber-200 bg-amber-50 px-5 py-3 text-amber-950 sm:items-center sm:px-8"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="mt-0.5 size-5 shrink-0 text-amber-700 sm:mt-0"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
      <p className="m-0 flex-1 text-sm leading-6">
        <strong className="font-semibold">Scheduled maintenance:</strong> Foodics BI will be
        temporarily unavailable today, September 15, starting at{" "}
        <time dateTime="2026-09-15T18:00:00Z" className="whitespace-nowrap font-semibold">
          18:00 UTC
        </time>
        . Please save your work before then.
      </p>
      <button
        type="button"
        aria-label="Dismiss maintenance announcement"
        onClick={() => {
          setVisible(false);
          try {
            localStorage.setItem(dismissalKey, "true");
          } catch {
            // Still allow dismissal when browser storage is unavailable.
          }
        }}
        className="-my-1 -me-1 flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-amber-800 hover:bg-amber-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-700"
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          className="size-4"
        >
          <path d="m6 6 12 12M18 6 6 18" />
        </svg>
      </button>
    </aside>
  );
}
